/* ── Export helpers ─────────────────────────────────────────────────────────── */
/**
 * Triggers a browser download for the given blob.
 */
function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/**
 * Serialise an array of application objects to a well-formatted JSON file
 * and trigger a download — runs entirely client-side, no extra endpoint needed.
 */
function exportAppsJSON(apps) {
  const exportData = apps.map((a) => ({
    id: a._id,
    applicantName: a.userName,
    applicantEmail: a.userEmail,
    phone: a.phone || "",
    jobTitle: a.jobTitle,
    experience: a.experience || "",
    linkedin: a.linkedin || "",
    portfolio: a.portfolio || "",
    coverLetter: a.coverLetter || "",
    status: a.status,
    appliedAt: a.appliedAt ? new Date(a.appliedAt).toISOString() : "",
    interviewInviteSent: a.interviewInviteSent || false,
    interviewInviteSentAt: a.interviewInviteSentAt
      ? new Date(a.interviewInviteSentAt).toISOString()
      : "",
  }));
  const blob = new Blob([JSON.stringify(exportData, null, 2)], {
    type: "application/json",
  });
  const date = new Date().toISOString().slice(0, 10);
  downloadBlob(blob, `applications_${date}.json`);
}

/**
 * Fetch the styled .xlsx file from the backend export endpoint and trigger
 * a download.  Query params mirror the current filter state.
 */
async function exportAppsExcel({ status, jobTitle } = {}) {
  const params = new URLSearchParams();
  if (status && status !== "all") params.set("status", status);
  if (jobTitle && jobTitle !== "all") params.set("jobTitle", jobTitle);

  const token = localStorage.getItem("ql_token");
  const res = await fetch(
    `${process.env.REACT_APP_API_URL || ""}/api/applications/export/excel?${params}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const date = new Date().toISOString().slice(0, 10);
  downloadBlob(blob, `applications_${date}.xlsx`);
}

export { exportAppsJSON, exportAppsExcel };
